<!-- Per city directory -->
<template>
  <div class="uk-container uk-background-muted">

    <template v-if="!dataLoading">
    <Button :isSecondary="true" @click="navigateToCityDirectoryPage" class="uk-margin uk-margin-top">
      <HomeIcon /> Back to {{company.directoryEntry.companyDirectoryCity}} directory
    </Button>

  <div class="uk-section uk-light uk-background-cover" style="background-image: linear-gradient(rgba(22, 36, 56, 0.5), rgba(1, 7, 14, 0.68)), url(&quot;https://unsplash.com/photos/nfQk1YdGoNc/download?force=true&amp;w=1920&quot;);"><div class="uk-container white-text">

    <h1>{{company.name}}</h1>
  </div></div>

    <!-- Company info block -->
    <div class="uk-card-default uk-margin-top uk-padding">
      <h2 class="uk-text-left">Contact Info</h2>
      <div class="uk-text-left">
        <p>Address: {{fullAddress(company.officeAddress)}}</p>
        <p>Email: {{company.email}}</p>
        <p>Phone #: {{company.phoneNumber}}</p>
      </div>
    </div>

    <div class="uk-card-default uk-margin-top uk-padding">
      <h2 class="uk-text-left uk-margin-remove-bottom">Who We Are</h2>
      <p class="uk-text-left">
      {{company.description}}
      </p>
    </div>

    <div class="uk-card-default uk-margin-top uk-padding">
      <h2 class="uk-text-left uk-margin-remove-bottom">Services Offered</h2>
      <p class="uk-text-left">
      {{company.servicesOffered}}
      </p>
    </div>

    <!-- <h2 class="uk&#45;text&#45;left">Equipment Types</h2> -->

    <a class="uk-text-medium uk-button uk-button-primary uk-margin uk-padding" :href="'mailto:' + company.email">Request a rate quotation</a>

    <br />

    <div class="uk-section uk-light uk-background-cover uk-margin-bottom" style="background-image: linear-gradient(rgba(22, 36, 156, 0.7), rgba(1, 7, 14, 0.68)), url(&quot;https://unsplash.com/photos/7n0JF9WvpJQ/download?force=true&amp;w=1920&quot;);"><div class="uk-container white-text">
  </div></div>

    </template>

  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
import HomeIcon from '@carbon/icons-vue/es/home/24';
import Button from '@/components/core/Button.vue';

import { addressMixin } from '@/utils/address';
import { Company } from '@/utils/company';

import { getCityDirectoryPage } from '../../router/route_utils';
import COMPANY_PROFILE from './gql/CompanyProfile.gql';

// @ts-ignore
UIkit.use(Icons);

export default defineComponent({
  name: 'CompanyInfoPage',
  components: {
    Button,
    HomeIcon,
  },
  props: {
    companyId: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      company: {} as Company,

      dataLoading: true,
      errorText: null,
    };
  },
  mixins: [addressMixin],
  methods: {
    navigateToCityDirectoryPage() {
      (this as any).$router.push(getCityDirectoryPage((this as any).company.directoryEntry.companyDirectoryCity));
    },
  },
  ...{
    apollo: {
      company: {
        query: COMPANY_PROFILE,
        variables() {
          return {
            companyId: (this as any).companyId,
          };
        },
        // update: (data) => data.company,
        result(result) {
          const vm = (this as any);

          console.log('[fetching company data] result: ', result);
          vm.dataLoading = false;
          vm.errorText = null;
        },
        error(error) {
          const vm = (this as any);

          vm.dataLoading = false;
          vm.errorText = 'Couldn\'t get company info';
          console.error('Fetching data failed: ', error);
        },
      },
    },
  },
});
</script>
